import React, {Component} from 'react';
import {Col, ControlLabel, FormControl, FormGroup} from 'react-bootstrap';

export default class TextareaField extends Component {

	render() {

		const {
			feedbackIcon,
			input,
			label,
			title,
			sizes,
			onChangeHook,
			quickValues,
			rows,
			meta: {error, warning, touched, asyncValidating},
			...props
		} = this.props;

		let message;
		const validationState = touched ? (error && "error") || (warning && "warning") || null : null;

		if (touched && (error || warning)) {
			message = <span className="help-block">{error || warning}</span>;
		}
		const labelSize = label ? sizes && sizes[0] ? sizes[0] : 2 : 0;
		const fieldSize = label ? (sizes && sizes[1] ? sizes[1] : 10) : (sizes && sizes[0] ? sizes[0] : 12);

		return (
			<FormGroup controlId={input.name} validationState={validationState} className={asyncValidating ? "loading" : ""} title={title}>
				{label ? <Col xs={labelSize} componentClass={ControlLabel}>{label}</Col> : null}
				<Col xs={fieldSize}>
					<FormControl {...props} {...input} componentClass="textarea" rows={rows || 2} onChange={(e) => {
						const value = e.target ? e.target.value : e.value;
						if (onChangeHook) {
							onChangeHook(value)
						}
						input.onChange(value)
					}}/>
					{quickValues && quickValues.length > 0 && quickValues
						.filter(q => !input.value || input.value.toLowerCase().indexOf(q.toLowerCase()) < 0)
						.map((quickValue, i) =>
							<button key={i} className={'btn btn-secondary btn-quick btn-xs pull-right'} onClick={(e) => {
								e.preventDefault();
								const v = input.value
									? input.value + ', ' + (quickValue[0].toLowerCase() + quickValue.substring(1))
									: quickValue;
								if (onChangeHook) {
									onChangeHook(v)
								}
								input.onChange(v);
							}}>{quickValue}</button>)}
					{feedbackIcon ? <FormControl.Feedback>{feedbackIcon}</FormControl.Feedback> : null}
					{message}
				</Col>
			</FormGroup>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/form/TextareaField.js